export interface Participant {
  id: string;
  displayName: string;
  formatted: string;
  particpantid: string;
  email: string;
  image: string;
}

export const StartMeeting = [
  "microphone",
  "camera",
  "closedcaptions",
  "desktop",
  "fullscreen",
  "fodeviceselection",
  "hangup",
  "profile",
  "chat",
  "recording",
  "livestreaming",
  "etherpad",
  "sharedvideo",
  "settings",
  "raisehand",
  "videoquality",
  "filmstrip",
  "stats",
  "shortcuts",
  "tileview",
  "videobackgroundblur",
  "download",
  "help",
  "mute-everyone",
  "e2ee",
  "security",
];

export const JoinMeeting = [
  "microphone",
  "camera",
  "fullscreen",
  "fodeviceselection",
  "hangup",
  "profile",
  "chat",
  "etherpad",
  "videoquality",
  "closedcaptions",
  "raisehand",
  "settings",
  "download",
];

export const StaffJoinMeeting = [
  "microphone",
  "camera",
  "closedcaptions",
  "desktop",
  "fullscreen",
  "fodeviceselection",
  "hangup",
  "profile",
  "chat",
  "recording",
  "livestreaming",
  "etherpad",
  "sharedvideo",
  "settings",
  "raisehand",
  "videoquality",
  "filmstrip",
  "stats",
  "shortcuts",
  "tileview",
  "videobackgroundblur",
  "download",
  "help",
  "e2ee",
  "security",
];



// WEBPACK FOOTER //
// ./src/app/shell/forms/shared-modals/online-session/interface.ts